<template>
  <div>
    <v-row
      v-for="(linha, index) in linhas"
      :key="index"
    >
      <v-col
        v-for="(item, index) in elementosPorLinha[linha]"
        :key="index"
        :cols="12/colunas"
        :sm="12/colunas"
      >
        <v-text-field
          v-if="item.linha === linha && item.idElementoTipo === 1 && item.multiline == false && item.visivel && item.ticketsRespostas[0]"
          v-model="item.ticketsRespostas[0].respostaTexto"
          :class="`${item.linha !== linha ? 'd-none' : ''}`"
          :label="item.label"
          :counter="item.maxLength"
          :hint="`Máximo de ${item.maxLength} caracteres`"
          :maxlength="item.maxLength"
          :rules="[(item.obrigatorio ? val => String(val).trim().length > 0 || 'Este campo é obrigatório' : true)]"
          outlined
          dense
          readonly
          :filled="!editavel"
          :disabled="!editavel"
          @input="adicionarFormularioResposta($event, item, index, 1)"
        ></v-text-field>

        <v-text-field
          v-if="item.linha === linha && item.idElementoTipo === 1 && item.multiline == false && item.visivel && !item.ticketsRespostas[0]"
          :class="`${item.linha !== linha ? 'd-none' : ''}`"
          :label="item.label"
          :counter="item.maxLength"
          :hint="`Máximo de ${item.maxLength} caracteres`"
          :maxlength="item.maxLength"
          :rules="[(item.obrigatorio ? val => String(val).trim().length > 0 || 'Este campo é obrigatório' : true)]"
          outlined
          dense
          readonly
          :filled="!editavel"
          :disabled="!editavel"
          @input="adicionarFormularioResposta($event, item, index, 1)"
        ></v-text-field>

        <!-- <text-field
          v-if="item.idElementoTipo === 1 && item.visivel"
          :componente-data="item"
          :validar-tamanho="!!item.maxLength"
        >
        </text-field> -->

        <v-textarea
          v-if="item.linha === linha && item.idElementoTipo === 1 && item.multiline == true && item.visivel && item.ticketsRespostas[0]"
          v-model="item.ticketsRespostas[0].respostaTexto"
          :class="`${item.linha !== linha ? 'd-none' : ''}`"
          :label="item.label"
          :counter="item.maxLength"
          :hint="`Máximo de ${item.maxLength} caracteres`"
          :maxlength="item.maxLength"
          :rules="[(item.obrigatorio ? val => String(val).trim().length > 0 || 'Este campo é obrigatório' : true)]"
          outlined
          dense
          readonly
          :filled="!editavel"
          :disabled="!editavel"
          @input="adicionarFormularioResposta($event, item, index, 1)"
        ></v-textarea>

        <v-textarea
          v-if="item.linha === linha && item.idElementoTipo === 1 && item.multiline == true && item.visivel && !item.ticketsRespostas[0]"
          :class="`${item.linha !== linha ? 'd-none' : ''}`"
          :label="item.label"
          :counter="item.maxLength"
          :hint="`Máximo de ${item.maxLength} caracteres`"
          :maxlength="item.maxLength"
          :rules="[(item.obrigatorio ? val => String(val).trim().length > 0 || 'Este campo é obrigatório' : true)]"
          outlined
          dense
          readonly
          :filled="!editavel"
          :disabled="!editavel"
          @input="adicionarFormularioResposta($event, item, index, 1)"
        ></v-textarea>

        <v-radio-group
          v-if="item.linha === linha && item.idElementoTipo === 2 && item.visivel && item.ticketsRespostas[0]"
          v-model="item.ticketsRespostas[0].idFormularioElementoOpcaoResposta"
          :class="`${item.linha !== linha ? 'd-none' : ''}`"
          row
          :rules="[(item.obrigatorio ? val => val !== null || 'Este campo é obrigatório' : true)]"
        >
          <v-radio
            v-for="opcao in item.opcoes"
            :key="opcao.id"
            class="mb-3"
            :items="opcao"
            :label="opcao.nome"
            :value="opcao.id"
            :filled="!editavel"
            :disabled="!editavel"
            readonly
            @change="adicionarFormularioResposta(opcao.id, item, index, 2)"
          ></v-radio>
        </v-radio-group>

        <v-radio-group
          v-if="item.linha === linha && item.idElementoTipo === 2 && item.visivel && !item.ticketsRespostas[0]"
          :class="`${item.linha !== linha ? 'd-none' : ''}`"
          row
          :rules="[(item.obrigatorio ? val => val !== null || 'Este campo é obrigatório' : true)]"
        >
          <v-radio
            v-for="opcao in item.opcoes"
            :key="opcao.id"
            class="mb-3"
            :items="opcao"
            :label="opcao.nome"
            :value="opcao.id"
            :filled="!editavel"
            :disabled="!editavel"
            readonly
            @change="adicionarFormularioResposta(opcao.id,item, index, 2)"
          ></v-radio>
        </v-radio-group>

        <v-checkbox
          v-if="item.linha === linha && item.idElementoTipo === 3 && item.visivel && item.ticketsRespostas[0]"
          v-model="item.ticketsRespostas[0].respostaBool"
          :class="`${item.linha !== linha ? 'd-none' : ''}`"
          :label="item.label"
          :rules="[(item.obrigatorio ? val => val === true || 'Este campo é obrigatório' : true)]"
          :filled="!editavel"
          :disabled="!editavel"
          readonly
          @change="adicionarFormularioResposta($event, item, index, 3)"
        ></v-checkbox>

        <v-checkbox
          v-if="item.linha === linha && item.idElementoTipo === 3 && item.visivel && !item.ticketsRespostas[0]"
          :class="`${item.linha !== linha ? 'd-none' : ''}`"
          :label="item.label"
          :rules="[(item.obrigatorio ? val => val === true || 'Este campo é obrigatório' : true)]"
          :filled="!editavel"
          :disabled="!editavel"
          readonly
          @change="adicionarFormularioResposta($event, item, index, 3)"
        ></v-checkbox>

        <v-select
          v-if="item.idElementoTipo === 4 && item.visivel && item.ticketsRespostas[0]"
          v-model="item.ticketsRespostas[0].idFormularioElementoOpcaoResposta"
          :items="item.opcoes"
          :label="item.label"
          item-text="nome"
          item-value="id"
          dense
          outlined
          hide-details="auto"
          :filled="!editavel"
          :disabled="!editavel"
          readonly
          :rules="[(item.obrigatorio ? val => !!val || 'Este campo é obrigatório' : true)]"
          @input="adicionarFormularioResposta($event, item, index, 4)"
        ></v-select>

        <v-select
          v-if="item.idElementoTipo === 4 && item.visivel && !item.ticketsRespostas[0]"
          :items="item.opcoes"
          :label="item.label"
          item-text="nome"
          item-value="id"
          dense
          outlined
          hide-details="auto"
          :filled="!editavel"
          :disabled="!editavel"
          readonly
          :rules="[(item.obrigatorio ? val => !!val || 'Este campo é obrigatório' : true)]"
          @input="adicionarFormularioResposta($event, item, index, 4)"
        ></v-select>

        <EncadeadoPdf
          v-if="item.idElementoTipo === 5 && item.visivel"
          :filled="!editavel"
          :disabled="!editavel"
          :componente-data="item"
          @adicionar-formulario-resposta="v => adicionarFormularioRespostaEncadeado(v.selecionado, v.id)"
        />

        <v-btn
          v-if="item.idElementoTipo === 6"
          class="ml-2"
          color="primary"
          readonly
          outlined
        >
          {{ item.label }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required, select } from '@core/utils/validation'
import Componente from '@/models/entities/formulario/componente/Componente'
import EncadeadoPdf from './EncadeadoPdf.vue'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'

export default {
  components: {
    EncadeadoPdf,
  },

  props: {
    editavel: {
      type: Boolean,
      required: true,
    },
    elementos: {
      type: Array,
      default: () => [],
    },
    linhas: {
      type: Number,
      default: 0,
    },
    colunas: {
      type: Number,
      default: 0,
    },
    formularioId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      formularioRespostas: [],
      selectedOption: 827,
      listEncadeados: [],
    }
  },

  computed: {
    elementosPorLinha() {
      const elementosPorLinha = []
      this.elementos.forEach(elementoPai => {
        elementoPai.forEach(item => {
          if (!elementosPorLinha[item.linha]) {
            elementosPorLinha[item.linha] = []
          }
          elementosPorLinha[item.linha].push(item)
        })
      })

      return elementosPorLinha
    },
  },

  methods: {
    adicionarFormularioResposta(valorSelecionado, item, index, tipo) {
      const formularioResposta = {
        idFormularioElemento: item.id,
        idFormularioElementoOpcaoResposta: null,
        respostaTexto: null,
        respostaBool: null,
        formularioId: this.formularioId,
      }

      // eslint-disable-next-line default-case
      switch (tipo) {
        case TiposDeComponentesEnum.TextBox:
          formularioResposta.respostaTexto = valorSelecionado
          break

        case TiposDeComponentesEnum.RadioGroup:
          formularioResposta.idFormularioElementoOpcaoResposta = valorSelecionado
          break

        case TiposDeComponentesEnum.CheckBox:
          formularioResposta.respostaBool = valorSelecionado
          break

        case TiposDeComponentesEnum.DropDownList:
          formularioResposta.idFormularioElementoOpcaoResposta = valorSelecionado
          break
      }

      const indexResposta = this.formularioRespostas.findIndex(resposta => resposta.idFormularioElemento === item.id)
      if (indexResposta !== -1) {
        this.formularioRespostas[indexResposta] = formularioResposta
      } else {
        this.formularioRespostas.push(formularioResposta)
      }

      this.$emit('atualizar-respostas', this.formularioRespostas)
    },

    adicionarFormularioRespostaEncadeado(valorSelecionado, item) {
      const formularioResposta = {
        idFormularioElemento: item,
        idFormularioElementoOpcaoResposta: null,
        respostaTexto: null,
        respostaBool: null,
        formularioId: this.formularioId,
      }

      formularioResposta.idFormularioElementoOpcaoResposta = valorSelecionado

      const indexResposta = this.formularioRespostas.findIndex(resposta => resposta.idFormularioElemento === item)
      if (indexResposta !== -1) {
        this.formularioRespostas[indexResposta] = formularioResposta
      } else {
        this.formularioRespostas.push(formularioResposta)
      }

      this.$emit('atualizar-respostas', this.formularioRespostas)
    },

    resetarSelectsSubsequentes(item, index, event) {
      const opcaoSelecionada = event
      const encadeados = item.elementoEncadeado.opcoes
      if (opcaoSelecionada) {
        // eslint-disable-next-line no-plusplus
        for (let i = index + 1; i < encadeados.length; i++) {
          this.$set(encadeados[i], 'opcaoSelecionada', null)
        }
      }
    },

    filtrarOpcoes(encadeado, index) {
      const encadeadoPai = index === 0 ? this.item : this.item.elementoEncadeado[index - 1]
      const opcaoPaiSelecionada = encadeadoPai.opcaoSelecionada
      if (opcaoPaiSelecionada) {
        return encadeado.opcoes.filter(op => op.idOpcaoPai === opcaoPaiSelecionada)
      }

      return []
    },

    list(item) {
      this.listEncadeados = Componente.listarComponentesEncadeados(item)
      this.listEncadeados = this.listEncadeados.map(element => ({ ...element, opcaoSelecionada: 0 }))

      return this.listEncadeados
    },

  },

  setup() {
    return {
      Componente,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
